"use client";

import {createContext, useContext, useState} from "react";

interface GlobalContextProps {
    currencyType: string;
    setCurrencyType: React.Dispatch<React.SetStateAction<string>>;
}

const GlobalContext = createContext<GlobalContextProps | undefined>(undefined);

export const GlobalContextProvider = ({children}: {children: React.ReactNode}) => {
    const [currencyType, setCurrencyType] = useState<string>("USD");

    return (
        <GlobalContext.Provider value={{currencyType, setCurrencyType}}>
            {children}
        </GlobalContext.Provider>
    )
}

export const useGlobalContext = () => {
    const context = useContext(GlobalContext);
    if (!context) {
        throw new Error("useGlobalContext must be used within GlobalContextProvider");
    }
    return context;
}